import { render } from "./wInputSuggest.vue?vue&type=template&id=638e6be3&ts=true"
import script from "./wInputSuggest.vue?vue&type=script&lang=ts"
export * from "./wInputSuggest.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__